import { Factory } from '../Factory';
import { Service } from '../Service';

namespace app.services.exporting {

  export class ExportService extends Service<any> {
    constructor(resource: any, rootScope: IRootScope, private configService, resourceWrapperService, exportDownloadService, private httpService, private notificationService) {
      super({resource, rootScope, resourceWrapperService});

      let exportResource = this.resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/export/:id`,
        {id: "@id", projectId: "@projectId"},
        {update: {method: "PUT"}});

      this.itemResource = this.resourceWrapperService.WrapActions(exportResource);

      // You could be on any page when the export finishes up
      this.RegisterCompleteEventListener("FeedService.ExportComplete", async (event, message) => {
        const promise1 = this.FindOne({id: message.id, projectId: message.projectId});
        // refresh the export list
        const promise2 = this.FindAll({
          id: "",
          projectId: message.projectId
        });

        const [_export, exports] = await Promise.all([promise1, promise2]);

        notificationService.addSuccess({
          title: "Export complete",
          description: `Export: ${message.name} has completed.`,
          buttons: `<a class="btn btn-success" href="${message.directDownloadPath}"><i class="icon-download-alt"></i> Download</a>`
        });

        this.rootScope.$broadcast("ExportService.update", message.projectId, exports);

        return _export;
      });

      this.RegisterCompleteEventListener("FeedService.ExportFailed", async (event, message) => {
        notificationService.addError({
          title: "Export failed",
          description: `Export: ${message.exportName} has failed.`
        });

        // refresh the export list
        const items = await this.FindAll({
          id: "",
          projectId: message.projectId
        });

        this.rootScope.$broadcast('ExportService.update', message.projectId, items)

        return null;
      });

      this.RegisterUpdateEventListener("FeedService.ExportUpdate", async (event, message) => {
        const item = await this.FindOne({id: message.exportId, projectId: message.projectId});

        item.job.percentageComplete = message.percentageComplete;

        return item;
      });
    }

    public Replay(exportItem: Export) {
      let url = `${this.configService.getServerBaseUrl()}/project/${exportItem.projectId}/export/${exportItem.id}/replay`;

      return this.httpService.$http({
        method: "POST",
        url: url
      }).success(() => {
        this.notificationService.addSuccess({
          title: "Export Replay started",
          description: "",
          timeout: 2500
        });
      }).error(() => {
        this.notificationService.addError({
          title: "Error Exporting",
          description: "That's embarrassing, please try again later",
          timeout: 5000
        });
      });
    }

    public GetExportStatistics(exportItem: Export) {
      let url = `${this.configService.getServerBaseUrl()}/project/${exportItem.projectId}/export/statistics`;

      return this.httpService.$http({
        method: "POST",
        data: exportItem,
        url: url
      });
    }

    protected StartNotification(projectId: string) {
      this.rootScope.$broadcast("ExportService.update", projectId, _.filter(this.items, (i: any) => i.projectId === projectId));
    }
  }


  frontendApp.factory("ExportService", ["$resource", "$rootScope", "ConfigService", "ResourceWrapperService", "ExportDownloadService", "HttpService", "NotificationService", Factory.Create(ExportService)]);
}
